import { updateWebsiteLeadUrl ,listWebsiteLeadUrl,addWebsiteLeadUrl } from '../api/index'
import axios from 'axios'
import { notification } from 'antd'
import { getToken } from '../../../request'


export const addWebsiteLeadAction = async params => {
  try {
    let { data } = await axios.post(
      updateAreaUrl(),
      { ...params },
      getToken()
    )
    return data
  } catch (err) {
    notification.error({
      message: 'Error'
    })
    return null
  }
}
export const updateAreaAction = async params => {
  try {
    console.log(params)
    let {data} = await axios.put(
      updateWebsiteLeadUrl(),
      {...params},
      getToken(),
    )
  
    return data
  } catch (err) {
    notification.error({
      message: 'Error',
    })
    return null
  }
}

export const listWebsiteLeadAction = async params => {
  try {
    let { data } = await axios.get(
      listWebsiteLeadUrl(), { params: { ...params }, ...getToken() })
    if (data.error) {
      notification.error({
        message: data.message
      })
    }
    return data
  } catch (err) {
    notification.error({
      message: 'Error'
    })
    return null
  }
}



